import React, { useContext, useEffect, useState, useCallback } from 'react';

import BenefitTile from './components/benefitTile/benefitTile';
import { BenefitCardListWrapper } from './Styles';

import { ResponsiveContainer } from '../../common/Styles';
import { BenefitDetailsData } from '../config';
import DisplayContext from '../../UtilityComponents/displayContext';
import { getMyBizBenefits } from '../landingApi';
import Panel from './components/panel';
import SignupFooter from '../components/SignUpFooter/SignUpFooter';
import { LANDING_CONSTS } from '../../AppConstants';
import { logPageLoadEvents } from '../../logging/omnitureService';

const BenefitDetails = ({
	params
}) => {
	const { isMobile: displayName } = useContext(DisplayContext);
	const isMobile = displayName == 'mobile';
	const type = params.type;
	const [bizBenefits, setBizBenefits] = useState(BenefitDetailsData[type] || BenefitDetailsData['DEF']);

	const getDetails = useCallback(async () => {
		const response = await getMyBizBenefits(type);
		if (response) {
			setBizBenefits((data) => ({
				...data,
				list: [...response.bizBenefits.benefits, ...data.list]
			}));
		}
	}, [setBizBenefits]);

	useEffect(() => {
		getDetails();
		logPageLoadEvents(LANDING_CONSTS.LANDING_PAGE_VIEW + '-' + type);
	}, []);

	const { list, carousel } = bizBenefits;

	return (
		<>
			<ResponsiveContainer>
				<Panel carouselData={carousel} isMobile={isMobile} />
				<BenefitCardListWrapper>
					{list && list.map((benefit, i) => (
						<BenefitTile key={i} isMobile={isMobile} data={benefit} />
					))}
				</BenefitCardListWrapper>
			</ResponsiveContainer>
			<SignupFooter $bg='#fff' />
		</>
	);
};

export default BenefitDetails;
